export type Document = {
    name: string;
    doc_id: number;
    doc_type_id: number;
    category_id: number;
    template_type_id: number;
    owner_id?: number;
    need_loop?: boolean;
    loop_base?: string;
    xcondition?: string;
    pkg_condition?: string;
    modify_type?: string;
    is_file_owned?: boolean;
    is_customized_for_firm?: boolean;
    is_customized_for_project?: boolean;
    is_doc_saved?: boolean;
    is_favorite?: boolean;
    is_uneditable?: boolean;
    tags?: Array<Tag | PSM | Creator | Category | Package>;
}

export type Tag = {
    name: string;
    parentNames?: Array<string>;
    children?: Array<Tag | PSM | Category | Package>;
}

export type PSM = Tag

export type Creator = Tag

export interface Category extends Tag {
    category_id: Array<number>;
    alias?: string;
    children?: Array<Category>;
}

export interface Package extends Tag {
    children?: Array<Package>;
    doc_list?: Array<Document>;
    tags?: Array<Tag | PSM>;
}


export const P: PSM = { name: "Purchase" };
export const S: PSM = { name: "Sale" };
export const M: PSM = { name: "Mortgage" };
export const psm = [P, S, M];

export const User: Creator = { name: "User" };
export const System: Creator = { name: "System" };
export const Custom: Creator = { name: "Custom" };
export const creators = [User, System, Custom];

export const CompoundDocument: Tag = { name: "Compound Document" };